import styled from 'styled-components';

const SItemTitle = styled.h3`
  font-family: var(--lingu-heading-font-family);
  font-style: normal;
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.5rem;
  margin-block-end: 0.75rem;
  color: var(--color-black);
  letter-spacing: -0.01em;

  @media (min-width: ${({ theme }) => theme.linguBptMd}) {
    margin-block-end: 1rem;
    font-size: 1.625rem;
    line-height: 2.25rem;
  }
`;

export default SItemTitle;
